import clsx from 'clsx';
import React from 'react';

import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

interface ProjectTitleProps {
  className?: string;
  title: string;
  titleCallout: string;
}

const ProjectTitle = ({ className, title, titleCallout }: ProjectTitleProps) => {
  let titleEnd = '';
  const titleSplit = title.split(titleCallout);

  const isCalloutInTitle = titleSplit.length > 1;
  if (isCalloutInTitle) {
    title = titleSplit[0].trim();
    titleEnd = titleSplit[1].trim();
  }

  return (
    <h1
      className={clsx(
        'mx-auto mb-24 mt-0 max-w-[720px] text-center font-suisse-screen text-headline-alt-md text-black sm:text-headline-alt-lg',
        className
      )}
    >
      {AuthoredContentReactToHtmlParser(
        `${title} <span class="text-primary-magenta">${titleCallout}</span> ${titleEnd}`
      )}
    </h1>
  );
};

export default ProjectTitle;
